import React, { forwardRef, useRef, useState } from 'react';
import styles from './index.module.less';
import classNames from 'classnames';
import { NewBaseIcon } from '@shared/components/base/NewBaseIcon';
import { TransparentBackground } from '../TransparentBackground';
import { error_picture } from '@shared/assets/svg/base';
export interface I_BaseImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
	imgStyle?: React.CSSProperties;
	imgClass?: string;
	opacityAnimation?: boolean;
	loadingComponent?: React.ReactNode;
	errorComponent?: React.ReactNode;
	loader?: boolean;
	transparentBackground?: number;
}

export const BaseImage = forwardRef<HTMLImageElement, I_BaseImageProps>(
	(
		{
			src,
			alt,
			className,
			style,
			imgStyle,
			imgClass = '',
			loadingComponent,
			errorComponent,
			opacityAnimation = false,
			loader,
			onLoad,
			onError,
			loading = 'lazy',
			transparentBackground = 0,
			...otherProps
		},
		ref,
	) => {
		const [isLoading, setIsLoading] = useState(true);
		const [isError, setIsError] = useState(false);
		const [isLoaded, setIsLoaded] = useState(false);
		const imageRef = useRef<HTMLImageElement>(null);

		const handleImageLoad = (ev: any) => {
			if (typeof onLoad === 'function') {
				onLoad(ev);
			}
			setIsLoading(false);
			setIsError(false);
			setIsLoaded(true);
		};

		const handleImageError = (ev: any) => {
			console.log('BaseImage加载图片出错', ev);
			if (typeof onError === 'function') {
				onError(ev);
			}
			setIsLoading(false);
			setIsError(true);
		};

		const defaultLoader = <div className={classNames(styles.loading, styles.gray_loading)}></div>;

		const defaultError = (
			<div className={styles.error}>
				<NewBaseIcon size={36} icon={error_picture} />
			</div>
		);

		const isTransparent = Boolean(transparentBackground) && src?.includes('.png');

		return (
			<div className={classNames(styles.container, className)} style={style} ref={ref}>
				<img
					ref={imageRef}
					src={src}
					alt={alt}
					onLoad={handleImageLoad}
					onError={handleImageError}
					className={imgClass}
					style={{
						...imgStyle,
						opacity: !opacityAnimation ? 1 : isLoaded && !isError && !isLoading ? 1 : 0,
						transition: 'opacity 0.25s ease-in-out',
					}}
					loading={loading}
					{...otherProps}
				/>
				{loader && isLoading && (loadingComponent || defaultLoader)}
				{isError && (errorComponent || defaultError)}
				<TransparentBackground show={isTransparent} size={transparentBackground} />
			</div>
		);
	},
);
